// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KsFt","label":"styles_label__1Jkj-"};